module.exports = __webpack_public_path__ + "static/img/06.a92497e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/06.jpg
// module id = HqCn
// module chunks = 1